import { combineReducers, createStore } from "redux";
import NotificationsReducers from "./components/redux/NotificationsReducers";

const rootReducer = combineReducers({ notifications: NotificationsReducers });
const store = createStore(rootReducer);

export default store;
